export default "__VITE_ASSET__8de04030__"